import { API_URLS } from '@bg-shared/constants/apiUrls';
import { GameId } from '@bg-shared/enums/GameId';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient/HttpClient.repository';
import { IExternalGameHandler, IPLSProxyParameter, IProxyResponse } from '../interfaces';
import { plsMessagesTracker } from './utils';
import { environmentSpecific } from '../decorators';

class PLSGameHandler implements IExternalGameHandler {
    private handleMessages(event: MessageEvent): void {
        plsMessagesTracker.handleMessages(event);
    }

    @environmentSpecific
    public async fetchLaunchUrl(gameId: GameId, language: string): Promise<string> {
        return httpClientRepository
            .get<IProxyResponse, IPLSProxyParameter>(`${API_URLS.PLS_LAUNCH}/${gameId}`, {
                params: {
                    language,
                },
            })
            .then((response) => response.url)
            .catch(() => null);
    }

    public initPM(): void {
        window.addEventListener('message', this.handleMessages);
    }

    public destroyPM(): void {
        window.removeEventListener('message', this.handleMessages);
    }
}

export const plsGameHandler = new PLSGameHandler();
